export default {
	title: 'Indicators',
	url: 'indicators',
	subtitle:
		'List the indicators of success (top targets), constraints and other critical elements that cristallise the overall goal. They can be financial, legal, technical, political, regulatory etc. Well defined, they “balance” quantity with quality.',
	no_description: 'No defined indicator',
	context_worse: 'Negative',
	context_best: 'Positive'
};
